// A partner link (?partner=CODE) is kept in localStorage for checkout, whichever create flow the visitor lands on:
// /create-book, /create-comic, a /create chooser pick or a format switch. Same plain-slug rule as the /create chooser.

export const PARTNER_CODE_KEY = 'partnerCode';
const PARTNER_CODE = /^[\w-]{1,64}$/;

type Storage = { setItem: (k: string, v: string) => void };

/** Stores a valid ?partner= from `search`; returns the stored code, or null (none, invalid, or storage blocked). */
export function capturePartnerCode(search: string, storage?: Storage): string | null {
  try {
    const code = (new URLSearchParams(search).get('partner') ?? '').trim();
    if (!PARTNER_CODE.test(code)) return null;
    (storage ?? window.localStorage).setItem(PARTNER_CODE_KEY, code);
    return code;
  } catch {
    return null; // storage blocked: checkout simply has no partner code
  }
}
